import { reduce, kebabCase } from 'lodash';
import type { KebabCase } from 'type-fest';

import {
    IBettingSpacing,
    DEFAULT_SPACING,
    SpacingCssVariables,
    СssSetNaming,
} from 'styles';
import isValidCssPair from './isValidCssPair';

function getSpacingCssVariables(
    spacing: Partial<IBettingSpacing>
): SpacingCssVariables {
    return reduce(
        { ...DEFAULT_SPACING, ...spacing },
        (acc, value, key: keyof IBettingSpacing) => {
            const validationError = isValidCssPair({
                naming: СssSetNaming.SPACING,
                key,
                value,
            });

            if (validationError) {
                console.error(validationError);

                return acc;
            }

            const cssProp = `--${
                kebabCase(key) as KebabCase<typeof key>
            }` as const;

            acc[cssProp] = `${value}px` as const;

            return acc;
        },
        {} as SpacingCssVariables
    );
}

export default getSpacingCssVariables;
